import { Infer, string, type } from "superstruct";

export const TokensResponseSchema = type({
    token: string(),
});

export type TokensResponse = Infer<typeof TokensResponseSchema>;
